if (document.querySelector(".slider-3")) {
  import("./modules/swiper3.module.js").then((module) => module.init());
}

// if (
//   document.querySelector(".box_inhalt.ext") ||
//   document.querySelector(".js-player.local")
// ) {
//   import("./modules/plyr.module.js").then((module) => module.init());
// }


// =============================================================
// WHEN COMPLETE
// functions which are called when the page is fully loaded
// =============================================================
// let attempts = 0;
// const whenComplete = () => {
//   if (++attempts > 30) return;
//   if (document.readyState === "complete") {
//     // --- code ---
//   } else {
//     setTimeout(() => whenComplete(), 400);
//   }
// };
// whenComplete();

// =============================================================
// STYLES COMPLETE
// Removes styles_essential when general styles are loaded
// =============================================================
// let styleAttempts = 0;
// const stylesComplete = () => {
//   if (++styleAttempts > 30) return;
//   if (document.querySelector("#spreld").getAttribute("rel") === "stylesheet") {
//     document.querySelector("#sess").remove();
//   } else {
//     setTimeout(() => stylesComplete(), 300);
//   }
// };
// stylesComplete();
